export { getV1Smartthermostat } from './DcSmartThermostatApiService';
export { getHosts, getState, linkHost } from './HostsService';
export { setHvacMode } from './ModeService';
export { getV1SmartthermostatGeneratedswagger } from './OpenApiSpecificationsService';
export { createOrder, getOffers, getDiscontinueReasons, discontinueIntake, discontinue } from './SalesService';
export { createOrderV2, getTermsAndConditions, getOffersV2 } from './SalesV2Service';
export { getScenes, setScenes } from './ScenesService';
export {
  setOverrideConfiguration,
  getOverrideConfiguration,
  overrideSchedule,
  getSchedule,
  createSchedule,
  deleteOverrideByTemperature,
  deleteOverrideByScene,
} from './ScheduleService';
export { createSession } from './SessionsService';
export { getOverview } from './SupportService';
export { getTelemetry } from './TelemetryService';
